export default function () {
  const section = document.querySelector('.content-single-trailer');

  if (section) {
    const name = section.dataset.name;

    const input = document.querySelector('.input-trailer-name');

    if (input) {
      input.value = name;
    }
  }
}
